var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrap",staticClass:"ext",class:{ 'histogram-wrap': _vm.isMobile }},[_c('div',{staticClass:"histogram-chart",style:(_vm.chartBoxStyle),attrs:{"id":"histogramChart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }